<template>
  <MainHeader />
  <MainSidebar />
  <!-- A contenção de overflow saiu daqui (era `overflow-hidden`) e virou regra de
       .main-content em css/style.scss, onde já vive o resto da geometria do shell. Ver o
       comentário de lá para o porquê de `overflow-x: clip`. -->
  <div
      class="main-content d-flex flex-column transition" id="main-content"
      :class="[
          { fullScreen: stateStoreInstance.isFullScreen }
      ]"
  >
    <router-view :key="route.fullPath" />
  </div>

  <div id="toastContainer"></div>
</template>



<script setup>
import { watchEffect, onMounted } from "vue";
import stateStore from "@/utils/store";
import { useRoute } from "vue-router";

import MainHeader from "@/components/layouts/Default/MainHeader.vue";
import MainSidebar from "@/components/layouts/Default/MainSidebar.vue";

const route = useRoute();



// Import components
 const stateStoreInstance = stateStore;

// Lifecycle hook for mounted
onMounted(() => {
  document.body.classList.add("bg-body-secondary");
});

// Watch for changes in the stateStoreInstance
watchEffect(() => {
  if (stateStoreInstance.open) {
    document.body.classList.remove("sidebar-show");
    document.body.classList.add("sidebar-hide");
  } else {
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
  }
});
</script>

